import React from 'react';
import './style.scss';
import {Coins} from '../Coins';

export const RatingCard = ({number, image, title, coins, active, error}) => {
  return <div className={'app-rating-card' + (active ? ' app-active' : '') + (error ? ' app-error' : '')}>
    <img loading="lazy" src={image} alt="" className="app-rating-card--image"/>
    <div className="app-rating-card--content">
      <div className="app-rating-card--title" data-title={title}/>
      <Coins coins={coins} big={false}/>
    </div>
    <div className="app-rating-card--number">{number}</div>
  </div>;
}